export default {"src":"/_next/static/media/user-register.00ec6acd.svg","height":400,"width":843,"blurWidth":0,"blurHeight":0};